<script lang="ts">
import { AccountStatus } from '@smartsupp/websocket-client-visitor'
import { scale } from 'svelte/transition'

import { testIds } from '@/constants'
import { accountStatus, assignedAgents, isAnyAssignedAgentOnline, isChatAssigned, isWidgetOnline } from '@/modules/chat'
import { t } from '@/modules/translations'

import Fade from './WidgetHeaderFade.svelte'

const scaleDelay = 150
const fadeDelay = 300

let assignedAgentDescription: string | false = $derived(
	$accountStatus === AccountStatus.Online && $assignedAgents.length === 1 && $assignedAgents[0].description,
)

let shouldDisplayOnlineText: boolean = $derived(
	$isChatAssigned ? $isAnyAssignedAgentOnline : $accountStatus === AccountStatus.Online,
)
</script>

<span class="flex items-center">
	{#if $isWidgetOnline}
		<div class="flex-shrink-0">
			<div
				in:scale={{ delay: scaleDelay }}
				class="w-2.5 h-2.5 mr-1.5 bg-green-400 border-2 border-green-400 rounded-full shadow"
				data-testid={testIds.headerBadge}
			></div>
		</div>
	{/if}
	<span class="text-xs opacity-60 truncate" data-testid={testIds.headerStatus}>
		{#if assignedAgentDescription}
			<Fade delay={fadeDelay}>{assignedAgentDescription}</Fade>
		{:else if shouldDisplayOnlineText}
			<Fade delay={fadeDelay}>{$t('statusBar.onlineText')}</Fade>
		{:else}
			<Fade delay={fadeDelay}>{$t('statusBar.offlineText')}</Fade>
		{/if}
	</span>
</span>
